(() => {
  'use strict';

  const registry = [];
  const normalizedScripts = new WeakSet();
  window.CorkopiaProductValidation = registry;

  const report = (product, element) => {
    registry.push({
      productId: product.identity.shopifyProductId,
      handle: product.identity.handle,
      valid: product.validation.valid,
      sellable: product.availability.sellable,
      state: product.availability.state,
      issues: product.validation.issues
    });

    if (window.Shopify?.designMode && product.validation.issues.length) {
      console.groupCollapsed(`[Corkopia product validation] ${product.identity.handle || product.identity.shopifyProductId || 'unknown product'}`);
      product.validation.issues.forEach((issue) => {
        const method = issue.severity === 'error' ? 'error' : 'warn';
        console[method](`${issue.code}: ${issue.message}`, { path: issue.path, element });
      });
      console.groupEnd();
    }
  };

  const normalizeNode = (script) => {
    if (!window.CorkopiaProductModel || !script || normalizedScripts.has(script)) return null;
    normalizedScripts.add(script);
    try {
      const raw = JSON.parse(script.textContent);
      const product = window.CorkopiaProductModel.adaptShopifyProduct(raw);
      const host = script.closest('[data-cork-product-card], [data-cork-product-detail]') || script.parentElement;
      if (host) {
        host.corkopiaProduct = product;
        host.dataset.normalizedFamily = product.classification.family || '';
        host.dataset.normalizedSize = product.classification.sizeClass || '';
        host.dataset.newArrival = String(product.classification.newArrival);
        host.dataset.availabilityState = product.availability.state;
        host.dataset.exactPiece = String(product.classification.exactPiece);
        host.dataset.quantityLimit = product.commerce.quantityLimit || '';
        host.dataset.productValid = String(product.validation.valid);
      }
      report(product, host);
      script.dispatchEvent(new CustomEvent('corkopia:product-normalized', {
        bubbles: true,
        detail: { product, host }
      }));
      return product;
    } catch (error) {
      registry.push({
        productId: null,
        handle: null,
        valid: false,
        sellable: false,
        state: 'invalid',
        issues: [{ code: 'raw_product_parse_error', path: 'raw', message: error.message, severity: 'error' }]
      });
      if (window.Shopify?.designMode) console.error('[Corkopia product validation] Raw product payload could not be normalized.', error);
      return null;
    }
  };

  const normalizeWithin = (scope = document) => {
    const products = [...scope.querySelectorAll('script[data-cork-product-raw]')]
      .map(normalizeNode)
      .filter(Boolean);
    document.dispatchEvent(new CustomEvent('corkopia:products-ready', {
      detail: { reports: registry, normalizedCount: products.length }
    }));
    return products;
  };

  window.CorkopiaProductRuntime = Object.freeze({
    normalizeNode,
    normalizeWithin,
    registry
  });

  document.addEventListener('DOMContentLoaded', () => normalizeWithin(document));
  document.addEventListener('corkopia:inventory-rendered', (event) => {
    const surfaceId = event.detail?.surfaceId;
    const scope = surfaceId
      ? [...document.querySelectorAll('[data-inventory-surface-id]')]
        .find((element) => element.dataset.inventorySurfaceId === surfaceId)
      : document;
    normalizeWithin(scope || document);
  });
})();
